import { useMemo } from 'react';

import { useDispatch, useSelector } from 'third-party';

import {
  tenantTypeaheadEndpoint,
  userTypeaheadEndpoint,
} from 'constants/endpoints';

import { appSelectors } from 'selectors';

import { bindActionCreators, httpMethod, simplifyBuilder } from 'utils/sra';

import { APIGuidTypeaheadRequestModel } from 'types/swaggerApi';

export type CacheState = object;

export const cacheState: CacheState = {};

const builder = simplifyBuilder(cacheState, {});

const tenantTypeahead = builder.createServerAction(
  (query: string, body: Partial<APIGuidTypeaheadRequestModel> = {}) => ({
    name: 'loadTenantTypeahead',
    url: tenantTypeaheadEndpoint(),
    body: {
      query: query,
      ...body,
    },
    method: httpMethod.post,
    // onSuccess: we don't put anything to store, just return result for typeahead
  }),
);

const loadUserTypeahead = builder.createServerAction(
  (
    tenantId: string,
    query: string,
    body: Partial<APIGuidTypeaheadRequestModel> = {},
  ) => ({
    name: 'loadUserTypeahead',
    url: userTypeaheadEndpoint(tenantId),
    body: {
      query: query,
      ...body,
    },
    method: httpMethod.post,
    // onSuccess: we don't put anything to store, just return result for typeahead
  }),
);

export const useCache = () => {
  const dispatch = useDispatch();
  const tenantId = useSelector(appSelectors.tenantId);

  return useMemo(
    () =>
      bindActionCreators(
        {
          loadUserTypeahead: loadUserTypeahead.bind(null, tenantId),
          tenantTypeahead,
        },
        dispatch,
      ),
    [dispatch, tenantId],
  );
};

export const cacheReducer = builder.getReducers();
